/**
 * YouTube embed URL helpers — referrer policy + youtube-nocookie (fixes Error 153).
 */

export const extractYoutubeVideoId = (url) => {
  if (!url) return null;
  const s = String(url).trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  try {
    const u = new URL(s);
    if (u.hostname === 'youtu.be') return u.pathname.slice(1).split('/')[0]?.slice(0, 11) || null;
    const shorts = u.pathname.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (shorts) return shorts[1];
    const embed = u.pathname.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
    if (embed) return embed[1];
    const v = u.searchParams.get('v');
    if (v) return v.slice(0, 11);
  } catch (_) {
    const m = s.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([a-zA-Z0-9_-]{11})/);
    if (m) return m[1];
  }
  return null;
};

export const getYoutubeEmbedUrl = (videoId, opts = {}) => {
  if (!videoId) return '';
  const params = new URLSearchParams({
    playsinline: '1',
    rel: '0',
    modestbranding: '1',
    enablejsapi: '1',
    autoplay: opts.autoplay !== false ? '1' : '0',
  });
  if (opts.loop) {
    params.set('loop', '1');
    params.set('playlist', videoId);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    params.set('origin', window.location.origin);
  }
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
};

export const youtubeThumbnail = (videoId, quality = 'hqdefault') =>
  videoId ? `https://img.youtube.com/vi/${videoId}/${quality}.jpg` : null;
